import { render, staticRenderFns } from "./PaginaOrdini.vue?vue&type=template&id=0be728b2"
import script from "./PaginaOrdini.vue?vue&type=script&lang=js"
export * from "./PaginaOrdini.vue?vue&type=script&lang=js"
import style0 from "./PaginaOrdini.vue?vue&type=style&index=0&id=0be728b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports